import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getResidentAmenityBookings, getResidentEvents, getResidentNotices } from './store/actions';

import Loading from './Loading';

import AmenityList from './AmenityList';
import EventList from './EventList';
import NoticeList from './NoticeList';
import AllAmenitiesList from './AllAmenitiesList';
import AllEventsList from './AllEventsList';
import AllNoticesList from './AllNoticesList';

import { colors } from 'helpers/ColorHelper';

export const DEFAULT = 'default';
export const ALL_AMENITIES = 'all_amenities';
export const ALL_EVENTS = 'all_events';
export const ALL_NOTICES = 'all_notices';

const StyledTabBodyContainer = styled.div`
  height: 100%;
  padding: 30px 18px 15px;
  background: ${colors.LOGIN_BACKGROUND_GREY};
`;

const StyledLoading = styled(Loading)`
  height: 100%;
`;

const TenantActivity = ({
  isLoading,
  cotenantId,
  propertyId,
  getResidentAmenityBookings,
  getResidentEvents,
  getResidentNotices,
}) => {
  const [view, setView] = useState(DEFAULT);

  useEffect(
    () => {
      getResidentAmenityBookings(cotenantId);
      getResidentEvents(cotenantId);
      getResidentNotices(cotenantId, propertyId);
    },
    [cotenantId, getResidentAmenityBookings, getResidentEvents, getResidentNotices, propertyId]
  );
  return isLoading ? (
    <StyledLoading />
  ) : (
    <StyledTabBodyContainer>
      {view === DEFAULT && (
        <React.Fragment>
          <AmenityList setView={setView} />
          <EventList setView={setView} />
          <NoticeList setView={setView} />
        </React.Fragment>
      )}
      {view === ALL_AMENITIES && <AllAmenitiesList setView={setView} />}
      {view === ALL_EVENTS && <AllEventsList setView={setView} />}
      {view === ALL_NOTICES && <AllNoticesList setView={setView} />}
    </StyledTabBodyContainer>
  );
};

const mapStoreToProps = store => ({
  cotenantId: store.landlordTenants.tenantDetails.id,
  propertyId: store.landlordTenants.tenantDetails.lease.property_id,
  isLoading: store.landlord.tenants.tenantActivity.isLoading,
});

const mapDispatchToProps = {
  getResidentAmenityBookings,
  getResidentEvents,
  getResidentNotices,
};

export default connect(mapStoreToProps, mapDispatchToProps)(TenantActivity);
